import { Challenge } from '@/types';
import { generateDailyChallenges, generateWeeklyChallenges } from './challenges/challengeGenerators';
import { updateChallengeProgress } from './challenges/challengeProgress';
import { getCompletedChallenges, getChallengeRewards } from './challenges/challengeUtils';

// Re-export all functions to maintain compatibility
export { updateChallengeProgress, getCompletedChallenges, getChallengeRewards };

export function initializeChallenges(): Challenge[] {
  return [
    ...generateDailyChallenges(),
    ...generateWeeklyChallenges()
  ];
}